import React from "react";
import ProductSideService from "./ProductSideService";
import BgImg from "../../assets/portfolio/bg2.png";
import OurClients from "../OurClients/OurClients";
import CRMIMAGE from "../../assets/product/crm.png";
import CRMHERO from "../../assets/product/CRM-Hero.png";
import {
  faUsers,
  faHandshake,
  faChartLine,
  faLock,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const VirtualPhoneNumber = () => {
  const crmPillars = [
    {
      title: "Customer Insights",
      description:
        "Leverage data to make informed decisions and drive business growth.",
      icon: faChartLine,
      bgColor: "bg-blue-100",
    },
    {
      title: "Relationship Building",
      description:
        "Foster stronger connections through personalized communication.",
      icon: faUsers,
      bgColor: "bg-green-100",
    },
    {
      title: "Automation & Efficiency",
      description:
        "Automate tasks to save time and improve operational efficiency.",
      icon: faHandshake,
      bgColor: "bg-yellow-100",
    },
    {
      title: "Security & Privacy",
      description:
        "Ensure data security and privacy with robust encryption and controls.",
      icon: faLock,
      bgColor: "bg-red-100",
    },
  ];
  return (
    <div>
      {/* Hero section */}
      <div className="relative bg-gradient-to-r from-[#0B0F2F] to-[#12164E] text-white py-10 px-4 md:px-8 lg:px-8 overflow-hidden">
        {/* Decorative Background Circles */}
        <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-blue-500 opacity-30 rounded-full blur-3xl z-0" />
        <div className="absolute bottom-[-150px] right-[-100px] w-[400px] h-[400px] bg-main1  opacity-20 rounded-full blur-3xl z-0" />

        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 md:gap-12 items-center">
          {/* Left Text Content */}
          <div>
            <h1 className="text-2xl md:text-4xl lg:text-4xl font-bold leading-tight text-[#8cd3fe]">
              Customer relationship management
            </h1>
            <p className="md:mt-6  mt-4 text-gray-300 text-[15px] md:text-lg">
              Efficiently manage customer interactions, strengthen
              relationships, and boost sales with a powerful Customer
              Relationship Management (CRM) system. Streamline communication,
              track engagement, and enhance customer satisfaction to drive
              business growth.
            </p>
            <button className="hidden md:block mt-8 px-6 py-3 rounded-full bg-main1 hover:bg-[#1c7ed6] text-white font-medium transition">
              Know More
            </button>
          </div>

          {/* Right Image/Graphic Content */}
          <div className="flex justify-center items-center">
            <img
              src={CRMIMAGE}
              alt="customer-relationship"
              className="w-full max-w-sm md:max-w-sm lg:max-w-md"
            />
          </div>
        </div>
      </div>
      {/* second sections here..... */}
      <div className="md:py-5  py-1 ">
        <h2 className="text-lg px-2 md:px-0 md:text-3xl font-semibold text-center mt-4 mb-2 text-gray-600">
          Customer relationship management (CRM)
        </h2>
        <div className="md:w-40 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-sm md:text-base text-gray-700 px-4 md:px-20 lg:px-40">
          {" "}
          Manage customer interactions, streamline sales, and boost growth with
          a powerful CRM system. Enhance communication and optimize customer
          experiences.
        </p>

        {/* Wrapper that allows scrolling */}
        <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}

          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={CRMHERO}
                  alt="crm"
                  className="w-full h-full  object-contain"
                />
              </div>

              {/* Text Content Section */}
              <div className="space-y-4 md:text-base  text-sm order-2 md:order-1 text-justify">
                <div>
                  <div className=" py-2">
                    <div className="space-y-3">
                      <p className="text-justify">
                        The term Customer Relationship describes systems and
                        processes within companies which, with the help of
                        customer data, aim to unify and improve customer service
                        to achieve higher levels of customer loyalty. Customer
                        Relationship brings together various departments, such
                        as sales and marketing, to ensure a uniform approach,
                        ultimately contributing to the company’s success.
                      </p>

                      <p className="text-justify">
                        Customer Relationship Management enables you to focus on
                        your organisation’s relationships with individuals –
                        whether customers, service users, colleagues, or
                        suppliers. CRM is not just for sales. Some of the
                        biggest gains in productivity come from moving beyond
                        CRM as a sales and marketing tool and embedding it
                        across the business – from HR to customer service and
                        supply chain management.
                      </p>

                      <p className="text-justify">
                        Cloud-based CRM systems, such as Salesforce, ensure
                        every user has access to the same information at all
                        times. Your sales team on the road can check data,
                        update it instantly after meetings, or work from
                        anywhere. The same information is available to anyone
                        who needs it, from the sales team to customer service
                        representatives.
                      </p>

                      <h4 className="text-main font-semibold  text-lg md:text-xl">
                        The Benefits of CRM
                      </h4>

                      <p className="text-justify">
                        Introducing a CRM platform has many benefits that have
                        shown real results, including direct improvements to the
                        bottom line. CRM applications have a proven track record
                        of increasing:
                      </p>
                      <ul className="space-y-3 pl-1 text-justify">
                        <li className="flex items-center space-x-3">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="text-sm text-main"
                          />
                          <span>Sales increase by up to 37%</span>
                        </li>
                        <li className="flex items-center space-x-3">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="text-main text-am"
                          />
                          <span>Sales Productivity boost by up to 44%</span>
                        </li>
                        <li className="flex items-center space-x-3">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="text-main text-sm"
                          />
                          <span>Forecast accuracy improvement by 48%</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sticky Sidebar */}
          <div className="sticky  top-20 self-start  p-3  h-fit">
            <ProductSideService />
          </div>
        </div>
      </div>

      <div
        className="py-5 px-5 relative"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-3xl md:text-4xl font-extrabold">
            <span className="text-black"> Customer Relationship </span>
            <span className="text-sky-500"> Management </span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-300 md:w-[150px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-500 text-base mt-4">
            What You Get Using Our CRM System"
          </p>
        </div>

        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {crmPillars?.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* client section */}
      <div>
        <OurClients />
      </div>
    </div>
  );
};

export default VirtualPhoneNumber;
